import { render, staticRenderFns } from "./searchPlts.vue?vue&type=template&id=a01824cc"
import script from "./searchPlts.vue?vue&type=script&lang=js"
export * from "./searchPlts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports